import { DatePipe } from '@angular/common'
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { Footnote } from 'src/app/models/footnote.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'

import { Overview } from '../../overview.model'
@Component({
  selector: 'price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss'],
  providers: [],
})
export class PriceComponent implements OnInit {
  @Input()
  overviewModel: Overview
  @ViewChild('simpleDialogContent') simpleDialogContent: TemplateRef<any>

  dialogTitle: string
  dialogBody: string
  aemContentSub: Subscription
  marketPrice: string
  expenseRatio: string
  grossExpenseRatio: string
  netExpenseRatio: string
  dailyMarketValue: string
  public SecyieldFlag = false
  fundDefinition = 'fund-definitions'
  @Input()
  expenseRatioFootnote: Footnote

  ngOnInit() {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  datePipe: any
  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {
    this.datePipe = new DatePipe('en-US')
  }
  get isMinimum(): boolean {
    return (!this.overviewModel?.isClosed ||
      !this.overviewModel?.isClosedToNewInvestors) &&
      this.overviewModel?.minimum
      ? true
      : false
  }

  parseAEMContent(content) {
    this.expenseRatio = this.centralContentService.getContentByBody(
      'fund_definitions_expense_ratio',
      content,
    ).contentValue
    this.grossExpenseRatio = this.centralContentService.getContentByBody(
      'fund_definitions_mf_non_vg_gross_expense_ratio',
      content,
    ).contentValue
    this.netExpenseRatio = this.centralContentService.getContentByBody(
      'fund_definitions_mf_non_vg_net_expense_ratio',
      content,
    ).contentValue
    this.dailyMarketValue = this.centralContentService.getContentByBody(
      'fund_definitions_daily_market_value',
      content,
    ).contentValue
  }
  // eslint-disable-next-line complexity,max-statements
  public setDialogInfo(longName = '', noteText = '', notecode = '') {
    this.dialogTitle = longName
    this.dialogBody = notecode.concat(' - ').concat(noteText)
    if (this.dialogTitle === 'Market price') {
      this.SecyieldFlag = true
      this.dialogBody = this.overviewModel?.closingMarketPrice
    }
    if (this.dialogTitle === 'Expense Ratio') {
      this.SecyieldFlag = true
      this.dialogBody = this.expenseRatio
    }
    if (this.dialogTitle === 'Gross Expense Ratio') {
      this.SecyieldFlag = true
      this.dialogBody = this.grossExpenseRatio
    }
    if (this.dialogTitle === 'Net Expense Ratio') {
      this.SecyieldFlag = true
      this.dialogBody = this.netExpenseRatio
    }
    if (this.dialogTitle === 'Daily market value') {
      this.SecyieldFlag = true
      this.dialogBody = this.dailyMarketValue
    }
    console.log(this.dialogBody)
  }
}
